module.exports = __webpack_public_path__ + "statics/img/3-6.d959373.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/3-6.png
// module id = gT2s
// module chunks = 1